import { useEffect, useState } from "react";
import './style.css'
import { Button } from "antd";
import TicketList from "./TicketManagement";
import { getTicketThread } from "../../api/api";
import { errorNotify } from "../../services/toast.notification";
import Spinner from "../../components/_common/Spinner";
export interface InputProps {
    ticketId: any,
    fromDate:any,
    toDate:any
  }
  
const TicketManagementThread = ({ticketId,fromDate,toDate}:InputProps) =>{
  const [data,setData] = useState([]);
  const [isLoading,setIsLoading] = useState(true);
  const [tableThreadVisible,setTableThreadVisible] = useState(true);
  const [fDate,setFromData] = useState(fromDate);
  const [tDate,setToData] = useState(toDate);
    
   const _getTicketThread = () => {
        getTicketThread(ticketId)
        .then((result:any) => {
          setData(result.data.data);
          setIsLoading(false);
          //console.log('backup info is: '+ result.data.json);
        })
        .catch((error) => {
          console.log(error);
          errorNotify(error.response.data.errorMessage,undefined,5000)
        }) 
        
        
    }

    const buttonClick =() =>{
      setTableThreadVisible(false);
      
    }

    useEffect(() => {
      _getTicketThread();
      }, [])
    
    return(
      <>
      {tableThreadVisible && (
         <div>
              <Button type="primary" onClick={()=>buttonClick()} style={{backgroundColor:"blue",float:"left"}} >بازگشت به صفحه تیکت ها </Button>
      </div>
      )}
     

      {  isLoading === false  && tableThreadVisible && (
        <div style={{marginTop:'40px'}}> 
        {
        data.length?       
            data.map((item:any) =>{
              return(
                <div className="row d-flex justify-content-around mt-3">
                  <div className={item.bit_Read?"borderd-content":"unReadTicket"}>
                      <div className="title">{item.int_TicketThreadDirection === 1? <span> {item.str_ProblemOwnerName} به {item.str_FullName} </span> : <span> {item.str_PersianSendDateTime}  </span> }</div>
                      <div className="title" style={{left:0}}>{item.int_TicketThreadDirection === 1? <span> {item.str_PersianSendDateTime} </span>: <span> {item.str_FullName} به {item.str_ProblemOwnerName} </span> }</div>

                        <div className="content">
                            <div className="row d-flex justify-content-around mt-3"> 
                            <p>{item.str_Text}</p>                      
                            </div>
                        </div>
                      </div>
                </div>
              )
            }) :
            <center><p>داده‌ای برای نمایش وجود ندارد.</p> </center>
        }
        </div>
    )
  }
     {
        isLoading === true  && (
        <Spinner />
      )
    }
     {
        tableThreadVisible === false  && (
        <TicketList  fromDate={fromDate} toDate={toDate} tableShow={true} /> 
      )
    }
    </>
    )


}
export default TicketManagementThread;